import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import TabsFilter from '~/components/Molecules/TabsFilter.vue';
import NativeCarousel from '~/components/Molecules/NativeCarousel.vue';
import ProductCardOrganism from '~/components/_next/organisms/ProductCardOrganism.vue';
import { useProduct } from '~/composables/_next/useProduct';
import { PRODUCTS_RECOMMENDATION_CAROUSEL_SLIDES_AMOUNT } from '~/constants';
import { isProductInStock, isProductAvailableInCountry, isProductDiscontinued } from '~/utils/ProductAvailability';
import useRightPath from '~/composables/useRightPath';
import { useLocalization } from '~/composables/_next/useLocalization';
import { filterProducts } from '~/utils/commercetools/products';
import { getIsNewProduct } from '~/helpers/productCardMethods';
import { gtmDiscountValue } from '~/helpers/gtm';
import { useSlugify } from '~/composables/useSlugify';
import { getProductPrice } from '~/utils/ProductPrice';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockProductsRecommendationGraphql',
  props: {
    title: null,
    tabsCollection: {
      default: function _default() {
        return {
          items: []
        };
      }
    },
    isHomePage: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useProduct = useProduct('BlockProductsRecommendationGraphql'),
      search = _useProduct.search,
      productsRecommendation = _useProduct.products;
    var _useSlugify = useSlugify(),
      slugify = _useSlugify.slugify;
    var _useLocalization = useLocalization(),
      country = _useLocalization.country;
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var _useNuxt2App = useNuxt2App(),
      $ct = _useNuxt2App.$vsf.$ct,
      $trackers = _useNuxt2App.$trackers;
    var products = computed(function () {
      var _productsRecommendati;
      return (_productsRecommendati = productsRecommendation.value) === null || _productsRecommendati === void 0 ? void 0 : _productsRecommendati.filter(function (product) {
        return isProductInStock(product) && isProductAvailableInCountry(product, country) && product.published;
      });
    });
    var dedupedProducts = computed(function () {
      var _products$value;
      return (_products$value = products.value) === null || _products$value === void 0 ? void 0 : _products$value.filter(function (product, index, self) {
        var isDuped = index === self.findIndex(function (t) {
          return t._slug === product._slug;
        });
        return isDuped;
      });
    });
    var allProductsIds = computed(function () {
      var _props$tabsCollection, _props$tabsCollection2, _props$tabsCollection3;
      var listOfProductsIds = ((_props$tabsCollection = props.tabsCollection) === null || _props$tabsCollection === void 0 ? void 0 : (_props$tabsCollection2 = _props$tabsCollection.items) === null || _props$tabsCollection2 === void 0 ? void 0 : (_props$tabsCollection3 = _props$tabsCollection2.map(function (tab) {
        return tab.listOfProducts;
      })) === null || _props$tabsCollection3 === void 0 ? void 0 : _props$tabsCollection3.flat()) || [];
      return _toConsumableArray(new Set(listOfProductsIds));
    });
    var tabs = computed(function () {
      var _props$tabsCollection4, _props$tabsCollection5;
      return (_props$tabsCollection4 = props.tabsCollection) === null || _props$tabsCollection4 === void 0 ? void 0 : (_props$tabsCollection5 = _props$tabsCollection4.items) === null || _props$tabsCollection5 === void 0 ? void 0 : _props$tabsCollection5.map(function (tab) {
        var tabProducts = [];
        var _iterator = _createForOfIteratorHelper(tab.listOfProducts),
          _step;
        try {
          var _loop = function _loop() {
            var productSku = _step.value;
            var foundProduct = products.value.find(function (product) {
              return product.sku === productSku;
            });
            if (foundProduct && getProductPath(foundProduct)) {
              tabProducts.push(foundProduct);
            }
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }

          // Recreate a compatible object to be able to access and filter variants in the product card
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var masterProductsWithVariants = filterMasterProductsWithVariants(tabProducts);
        var sortedProducts = sortProductsBySku(masterProductsWithVariants, tab.listOfProducts);
        return _objectSpread(_objectSpread({}, tab), {}, {
          listOfProducts: sortedProducts
        });
      });
    });
    var currentTabIndex = ref(0);
    /**
     * Sets the current tab index.
     *
     * @param      {Number}  index   The index
     */
    function setCurrentTabIndex(index) {
      currentTabIndex.value = index;
    }

    /**
     * Triggers GTM tracking for the tab at the given index.
     *
     * The event structure follows the requested configuration:
     * - `event_label` and `item_list_name` take the value of the current tab title.
     * - `item_location` is generated in the format "{selection}_{index}".
     * - Each product is iterated over and its data is formatted accordingly.
     *
     * @param index - The index of the tab for which to trigger tracking.
     */
    function trackCurrentTabEvent(index) {
      var currentTab = tabs.value[index];
      if (!currentTab) return;
      $trackers.gtm.pushEvent('product_list_view', {
        event_category: 'ecommerce',
        event_action: 'impressions',
        event_label: "".concat(currentTab.title, "_").concat(index + 1),
        event_name: 'view_item_list',
        ecommerce: {
          item_list_id: currentTab.title,
          item_list_name: currentTab.title,
          items: currentTab.listOfProducts.map(function (product, i) {
            return {
              item_id: "SKU_".concat(product.sku),
              item_sku: product.sku,
              item_name: product === null || product === void 0 ? void 0 : product._name,
              index: i + 1,
              new_product: getIsNewProduct(product),
              discount: gtmDiscountValue(getProductPrice(product).regular, getProductPrice(product).special),
              discount_in_cents: gtmDiscountValue(getProductPrice(product).regular, getProductPrice(product).special, true),
              price: getProductPrice(product).regular,
              price_in_cents: Number((getProductPrice(product).regular * 100).toFixed(2)),
              is_in_stock: isProductInStock(product),
              item_location: slugify("".concat(currentTab.title, "_").concat(i + 1))
            };
          })
        }
      });
    }

    /**
     * Sort products by their sku
     *
     * @param      {Array}   products  The products
     * @param      {Array}  skuList   The sku list
     * @return     {Array}   Sorted array of products
     */
    function sortProductsBySku(products, skuList) {
      return products.sort(function (a, b) {
        return (skuList === null || skuList === void 0 ? void 0 : skuList.indexOf(a.sku)) - (skuList === null || skuList === void 0 ? void 0 : skuList.indexOf(b.sku));
      });
    }

    /**
     * Determines if sellable product variants.
     *
     * @param      {Object}   product  The product
     * @return     {boolean}  True if sellable product variants, False otherwise.
     */
    function hasSellableProductVariants(product) {
      var _product$variants;
      if (!((_product$variants = product.variants) !== null && _product$variants !== void 0 && _product$variants.length)) return true;
      return !product.variants.every(function (variant) {
        return isProductDiscontinued(variant);
      });
    }

    /**
     * Filters the products to keep only the master variants
     *
     * @param      {Array}  products           The products
     * @return     {Array}   The filtered products
     */
    function filterMasterProductsWithVariants(products) {
      var filteredProducts = [];
      var _iterator2 = _createForOfIteratorHelper(filterProducts(products, {
          master: true
        })),
        _step2;
      try {
        var _loop2 = function _loop2() {
          var _product$_original, _product$_original$ma, _product$_original$ma2, _product$_original$ma3, _product$_original2, _product$_original2$m, _product$_original2$m2, _product$_original2$m3, _product$_original2$m4;
          var product = _step2.value;
          if (!isProductAvailableInCountry(product, country)) return 1; // continue
          var masterSku = product === null || product === void 0 ? void 0 : (_product$_original = product._original) === null || _product$_original === void 0 ? void 0 : (_product$_original$ma = _product$_original.masterData) === null || _product$_original$ma === void 0 ? void 0 : (_product$_original$ma2 = _product$_original$ma.current) === null || _product$_original$ma2 === void 0 ? void 0 : (_product$_original$ma3 = _product$_original$ma2.masterVariant) === null || _product$_original$ma3 === void 0 ? void 0 : _product$_original$ma3.sku;

          /**
           * Filters out the master variant from allVariants and maps remaining variants
           * by injecting the parent product's _id into each variant to fix OOS modal issue.
           */
          var variants = product === null || product === void 0 ? void 0 : (_product$_original2 = product._original) === null || _product$_original2 === void 0 ? void 0 : (_product$_original2$m = _product$_original2.masterData) === null || _product$_original2$m === void 0 ? void 0 : (_product$_original2$m2 = _product$_original2$m.current) === null || _product$_original2$m2 === void 0 ? void 0 : (_product$_original2$m3 = _product$_original2$m2.allVariants) === null || _product$_original2$m3 === void 0 ? void 0 : (_product$_original2$m4 = _product$_original2$m3.filter(function (variant) {
            return (variant === null || variant === void 0 ? void 0 : variant.sku) !== masterSku;
          })) === null || _product$_original2$m4 === void 0 ? void 0 : _product$_original2$m4.map(function (variant) {
            return _objectSpread(_objectSpread({}, variant), {}, {
              _id: product === null || product === void 0 ? void 0 : product._id
            });
          });
          var productWithVariants = _objectSpread(_objectSpread({}, product), {}, {
            variants: variants
          });
          if (hasSellableProductVariants(productWithVariants)) {
            filteredProducts.push(productWithVariants);
          }
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          if (_loop2()) continue;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return filteredProducts;
    }

    /**
     * Gets the image loading.
     *
     * @param      {number}   tabIndex      The tab index
     * @param      {number}   productIndex  The product index
     * @return     {string}  The image loading.
     */
    function getImageLoading(tabIndex, productIndex) {
      return tabIndex === 0 && productIndex < 4 ? 'eager' : 'lazy';
    }
    useLazyAsyncData('component-organism-blockProductsRecommendationGraphql', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _productsRecommendati2, _props$tabsCollection6, _props$tabsCollection7;
      var _props$tabsCollection8, _props$tabsCollection9;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(((_productsRecommendati2 = productsRecommendation.value) === null || _productsRecommendati2 === void 0 ? void 0 : _productsRecommendati2.length) === 0 && ((_props$tabsCollection6 = props.tabsCollection) === null || _props$tabsCollection6 === void 0 ? void 0 : (_props$tabsCollection7 = _props$tabsCollection6.items) === null || _props$tabsCollection7 === void 0 ? void 0 : _props$tabsCollection7.length) > 0)) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return search({
              perPage: ((_props$tabsCollection8 = props.tabsCollection) === null || _props$tabsCollection8 === void 0 ? void 0 : (_props$tabsCollection9 = _props$tabsCollection8.items) === null || _props$tabsCollection9 === void 0 ? void 0 : _props$tabsCollection9.length) * PRODUCTS_RECOMMENDATION_CAROUSEL_SLIDES_AMOUNT,
              page: 1,
              skus: allProductsIds.value
            });
          case 3:
            return _context.abrupt("return", true);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    useLazyAsyncData('gtm-blockProductsRecommendationGraphql', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            trackCurrentTabEvent(currentTabIndex.value);
            return _context2.abrupt("return", true);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), {
      watch: [productsRecommendation],
      server: false
    });
    return {
      __sfc: true,
      props: props,
      search: search,
      productsRecommendation: productsRecommendation,
      slugify: slugify,
      country: country,
      getProductPath: getProductPath,
      $ct: $ct,
      $trackers: $trackers,
      products: products,
      dedupedProducts: dedupedProducts,
      allProductsIds: allProductsIds,
      tabs: tabs,
      currentTabIndex: currentTabIndex,
      setCurrentTabIndex: setCurrentTabIndex,
      trackCurrentTabEvent: trackCurrentTabEvent,
      sortProductsBySku: sortProductsBySku,
      hasSellableProductVariants: hasSellableProductVariants,
      filterMasterProductsWithVariants: filterMasterProductsWithVariants,
      getImageLoading: getImageLoading,
      TabsFilter: TabsFilter,
      NativeCarousel: NativeCarousel,
      ProductCardOrganism: ProductCardOrganism
    };
  }
});